import { setFactory } from "./timerWorkerRegistry";
import timerWorkerFactory from "./timerWorkerFactory";

export default function registerTimerWorkerFactory() {
    setFactory(timerWorkerFactory);
}
